import React, { useEffect, useState } from 'react'
import ReservationBoxCheckout from './ReservationBoxCheckout'
import { PaymentAPI } from '../../api/PaymentAPI'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import scheduleImg from '../../assets/images/schedule_1.png'
import { Accordion, AccordionDetails, AccordionSummary, Button, Typography } from '@mui/material'
import { rootAction } from '../../redux/reducer/rootReducer'
import Loader from '../../component/Loader'
import { IoIosClose } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import PopUpAlert from '../../component/PopUpAlert'
import { CalendarAPI } from '../../api/CalendarAPI'
import { isClubOwner, isClubStaff, isCoach } from '../../util/UserRoles'

const CartDetails = () => {
    document.title = "Reservation Checkout"
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const { isPaymentDoneForReservation } = useSelector((store) => store.root);
    const [checkoutDetails, setCheckoutDetails] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loadingCount, setLoadingCount] = useState(0);
    const [priceBreakdown, setPriceBreakdown] = useState({});
    const [expanded, setExpanded] = useState({});

    const handleExpansion = (index) => {
        setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
    };

    const startLoading = () => {
        setLoadingCount(prevCount => prevCount + 1);
    };
    const finishLoading = () => {
        setLoadingCount(prevCount => prevCount - 1);
    };

    useEffect(() => {
        if (selectedClub.clubId && userInfo.userId) {
            calculatePricing();
        }
    }, [userInfo.userId, selectedClub.clubId, isPaymentDoneForReservation.status])

    const calculatePricing = async () => {
        try {
            const paymentInfo = {
                userId: userInfo.userId,
                clubId: selectedClub.clubId
            }
            startLoading();
            const response = await PaymentAPI.postCalculatePricing(paymentInfo);
            setCheckoutDetails(response.Data);
            let data = response.Data.priceBreakdown;
            const priceBreakdownData = new Map();
            for (let dataKey in data) {
                const newPriceBreakdown = [];
                for (let key in data[dataKey]) {
                    const splitKey = key.split('-');
                    if (Number(data[dataKey][key]) != 0) {
                        newPriceBreakdown.push({
                            start: splitKey[0],
                            end: splitKey[1],
                            price: splitKey[2],
                            dayType: splitKey[3],
                            hours: data[dataKey][key]
                        });
                    }
                }
                priceBreakdownData.set(dataKey, newPriceBreakdown);
            }
            setPriceBreakdown(priceBreakdownData);


        } catch (error) {
            console.error(error);
        } finally {
            finishLoading();
        }

    }
    const handleConfirmFreeReservation = async () => {
        try {
            startLoading();
            const response = await CalendarAPI.postConfirmFreeReservation(userInfo.userId, selectedClub.clubId);
            dispatch(rootAction.setReservationPaymentStatus(({ status: true, type: 'payment' })));
            finishLoading();
            dispatch(rootAction.setWarningMessage({id:Date.now(), type: 'success', message: 'Reservation confirmed successfully.' }));
            setTimeout(() => {
                 dispatch(rootAction.setIsUpdateTotalSchedule(true));
            }, 1000);
            navigate('/');

            finishLoading();
        } catch (error) {
            finishLoading();
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', message: 'Something went wrong' }));
        }
    }

    const handleCheckout = async () => {

        if (checkoutDetails?.warning !== "") {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'warning', message: checkoutDetails?.warning }));
            return;
        }

        if (checkoutDetails?.totalAmount === '0.00') {
            handleConfirmFreeReservation();
            return;
        }
        try {
            const paymentDetails = {
                userId: (isClubOwner(userInfo) || isClubStaff(userInfo)) ? checkoutDetails?.reservations[0].players[0] : userInfo.userId,
                paymentCreatedBy: userInfo.userId,
                clubId: selectedClub.clubId,
                amount: checkoutDetails?.totalAmount,
                paymentType: "onReservationPayment"
            }
            startLoading();
            const paymentIntentResponse = await PaymentAPI.postCreatePaymentIntent(paymentDetails);
            dispatch(rootAction.setPaymentIntentId(paymentIntentResponse.Data.paymentIntentId));
            finishLoading();
            navigate('/payment', {
                state: {
                    clientSecret: paymentIntentResponse.Data.paymentIntentClientSecret,
                    paymentIntentId: paymentIntentResponse.Data.paymentIntentId,
                    reservationFor: paymentDetails.userId,
                }
            })
        } catch (error) {
            finishLoading();
        }
    }
    if (loadingCount > 0) {
        return <Loader />
    }

    return (
        <div className='cart_page_container'>
            {checkoutDetails && checkoutDetails.reservations.length != 0
                ?
                <>
                    <div className="reservation_details_for_checkout" >
                        {/* {checkoutDetails?.reservations?.length != 0 &&
                       <Timer />
                       } */}
                        <h1>Reservation Details:</h1>

                        {checkoutDetails?.reservations?.map((item) =>
                            <ReservationBoxCheckout
                                key={item.reservationId}
                                clubId={selectedClub.clubId}
                                startLoading={startLoading}
                                finishLoading={finishLoading}
                                reservation={item}
                                isReservation={true}
                            />
                        )}
                    </div>
                    <div className="reservation_price_detals_body">
                        <h1>Price Details</h1>
                        <div className="reservation_price_detals_row">
                            <p>{Number(checkoutDetails?.totalReservations) > 1 ? 'Total Reservations' : 'Total Reservation'}</p>
                            <p>{checkoutDetails?.totalReservations}</p>
                        </div>
                        <div className="reservation_price_detals_row">
                            <p>{Number(checkoutDetails?.totalHour) > 1 ? 'Total Hours' : 'Total Hour'}</p>
                            <p>{checkoutDetails?.totalHour}</p>
                        </div>
                        <div className="reservation_horizontal_line"></div>
                        {[...priceBreakdown?.entries()].map(([name, priceList], index) =>
                        (<Accordion
                            expanded={expanded[index]}
                            onChange={() => handleExpansion(index)}
                            sx={{
                                boxShadow: 'none',
                                border: '1px solid #E5E5E5',
                                borderRadius: '5px',
                                marginBottom: '10px'
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<IoIosArrowDown />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <Typography component="span">{name?.slice(37)}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {priceList.length != 0 && priceList.map((item) =>
                                    <div className="reservation_price_detals_row">
                                        <p>{item.dayType + '('}
                                            {(Number(item.start) / 60) >= 12
                                                ? (Number(item.start) / 60) == 12
                                                    ? (Number(item.start) / 60)
                                                    : (Number(item.start) / 60) - 12
                                                : (Number(item.start) / 60)}{(Number(item.start) / 60) >= 12 ? 'pm' : 'am'}
                                            {' - '}
                                            {(Number(item.end) / 60) >= 12
                                                ? (Number(item.end) / 60) == 12
                                                    ? (Number(item.end) / 60) : (Number(item.end) / 60) - 12
                                                : (Number(item.end) / 60)}{(Number(item.end) / 60) >= 12 ? 'pm)' : 'am)'}
                                        </p>
                                        <p className='price-break-down-price'>${Number(item?.price)?.toFixed(2)}<IoIosClose />{Number(item.hours) / 60}{(Number(item.hours) / 60) > 1 ? ' Hours' : ' Hour'}</p>
                                    </div>
                                )}
                            </AccordionDetails>
                        </Accordion>))}

                        <div className="reservation_horizontal_line"></div>
                        <div className="reservation_price_detals_row">
                            <p>Total Amount:</p>
                            <p>${checkoutDetails?.totalAmount}</p>
                        </div>
                        <button onClick={handleCheckout}>checkout</button>
                    </div>
                </>
                :
                <div className='checkout_reservation_not_found'>
                    <img src={scheduleImg} alt="" />
                    <h1>Reservations for checkout were not found.</h1>
                    <Button onClick={() => {
                        navigate('/calendar');
                        dispatch(rootAction.setSlideBarLink('calendar'));
                    }} variant='contained'>Book reservation</Button>
                </div>}
        </div>
    )
}

export default CartDetails